import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { useMedia } from 'react-use'
import { gsap } from 'gsap'
import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin'
import { SplitText } from 'gsap/SplitText'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(SplitText)
gsap.registerPlugin(MorphSVGPlugin)
window.requestAnimationFrame = window.requestAnimationFrame.bind(window) // Reqd for IE Edge in dev
gsap.registerPlugin(ScrollTrigger)

const SideBgRight = (props) => {
    const isMobile = useMedia('(max-width: 992px)')
    const container = useRef(null)
    const scene1 = useRef(null)
    const scene2 = useRef(null)

    useEffect(() => {
        if (!isMobile && container.current) {
            const morph = gsap.timeline()
            morph.to(scene1.current, {
                morphSVG: {
                    shape: scene2.current,
                    type: 'linear'
                },
                scrollTrigger: {
                    trigger: container.current,
                    start: 'top+=100 center',
                    end: '+=400',
                    scrub: 0.5
                }
            })
        }
    }, [])

    return (
        <div ref={container} className='d-none d-lg-block' style={{ width: '100%' }}>
            <svg viewBox='0 0 316 808' className='bg-shape-right'>
                <g transform='translate(-1605.000000, -715.000000)'>
                    <path ref={scene1} fill='#ECF9F0' d='M1606.72275,1522.52634 C1724.95821,1487.69036 1827.20078,1375.80284 1904.44806,1101.37227 C1980.94274,829.615447 1802.16339,773.153452 1605.71838,715.205859 C1605.71838,770.28419 1605.15688,1462.6 1606.72275,1522.52634 Z' transform='translate(1764.078438, 1118.866100) scale(-1, 1) translate(-1764.078438, -1118.866100)' />
                    <path ref={scene2} style={{ display: 'none' }} fill='#ECF9F0' d='M1560.79601,1592.02007 C1609.22901,1465.2478 1723.1922,1325.00779 1858.11172,1181.3608 C2037.58086,990.282425 1795.49639,742.024507 1560.79601,795.338603 C1561.21857,826.44581 1561.21857,1541.54135 1560.79601,1592.02007 Z' transform='translate(1740.609286, 1190.010035) scale(-1, 1) translate(-1740.609286, -1190.010035)' />
                </g>
            </svg>
        </div>
    )
}

SideBgRight.propTypes = {}

export default SideBgRight



// WEBPACK FOOTER //
// ./resources/js/components/SideBgRight.js